<!-- En confirm-cancel-dialog.html -->
<div class="dialog-container">
  <header class="dialog-header">
    <mat-icon [ngClass]="data.icon === 'warning' ? 'danger' : 'info'">{{ data.icon }}</mat-icon>
    <h2>{{ data.title }}</h2>
  </header>

  <mat-dialog-content class="dialog-content">
    @if (data.isWarning) {
      <p>¿Seguro que deseas eliminar <strong>{{ data.productName }}</strong> de tu pedido?</p>
      <p>Esta acción no se puede deshacer.</p>
    } @else {
      <p><strong>{{ data.productName }}</strong></p>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="actions-row">
    <button class="btn-action secondary" mat-dialog-close mat-flat-button>
      VOLVER
    </button>
    <button [class]="data.clazz" [mat-dialog-close]="true" mat-flat-button>
      {{ data.textButon }}
    </button>
  </mat-dialog-actions>
</div>
